import { Component } from '../lib/ComponentBase';
import { simpleComponent } from '../lib/ComponentHelpers';
import type { TagComponent } from '../types/Components';

/**
 * A tag component for entities that are part of the terrain.
 */
class IsTerrain extends Component implements TagComponent {}

export default simpleComponent(IsTerrain);
